import Home from "../../views/dashboard/home";
import Users from "../../views/dashboard/users";
import APIkeys from "../../views/dashboard/apikeys";
import Builder from "../../views/dashboard/builder";
import Members from "../../views/dashboard/members";
import Events from "../../views/dashboard/events";
import EventDetail from "../../views/dashboard/events/EventDetail";

import LoggedMiddleware from "../../middlewares/LoggedMiddleware";
import CompanyMiddleware from "../../middlewares/CompanyMiddleware";

import APIKeyModuleMiddleware from "../../middlewares/APIKeyModuleMiddleware";
import RWAModuleMiddleware from "../../middlewares/RWAModuleMiddleware";
import EventsModuleMiddleware from "../../middlewares/EventsModuleMiddleware";
import SSOModuleMiddleware from "../../middlewares/SSOModuleMiddleware";

import DashboardSSO from "../../views/dashboard/sso";

import RWA from "../../views/dashboard/rwa";
import RWAFiltered from "../../views/dashboard/rwa/RWAFiltered";
import RWACreate from "../../views/dashboard/rwa/RWACreate";
import RWAView from "../../views/dashboard/rwa/RWAView";
import WalletConfiguration from "../../views/dashboard/wallet-configuration";
import Workflows from "../../views/dashboard/workflows";
import WorkflowEditor from "../../views/dashboard/workflows/WorkflowEditor";
import EmailVerifiedMiddleware from "../../middlewares/EmailVerifiedMiddleware";
import InvitationMiddleware from "../../middlewares/InvitationMiddleware";
import Tokens from "../../views/dashboard/tokens";

export default [
    {
        name: 'Home',
        layout: '/dashboard',
        path: '/home',
        component: Home,
        middlewares: [InvitationMiddleware, LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware],
    },
    {
        name: 'Users',
        layout: '/dashboard',
        path: '/admin-users',
        component: Users,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware],
    },
    {
        name: 'APIKeys',
        layout: '/dashboard',
        path: '/apikeys',
        component: APIkeys,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware, APIKeyModuleMiddleware],
    },
    {
        name: 'Design',
        layout: '/dashboard',
        path: '/design',
        component: Builder,
        middlewares: [LoggedMiddleware,EmailVerifiedMiddleware, CompanyMiddleware, EmailVerifiedMiddleware],
    },
    {
        name: 'Wallet Configuration',
        layout: '/dashboard',
        path: '/wallet-configuration',
        component: WalletConfiguration,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware, EmailVerifiedMiddleware],
    },
    {
        name: 'Members',
        layout: '/dashboard',
        path: '/members',
        component: Members,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware],
    },
    {
        name: 'Events',
        layout: '/dashboard',
        path: '/events',
        component: Events,
        middlewares: [LoggedMiddleware, CompanyMiddleware, EventsModuleMiddleware],
    },
    {
        name: 'Event Detail',
        layout: '/dashboard',
        path: '/events/:id',
        component: EventDetail,
        middlewares: [LoggedMiddleware, CompanyMiddleware, EventsModuleMiddleware],
    },
    {
        name: 'Rwa',
        layout: '/dashboard',
        path: '/rwa',
        component: RWA,
        middlewares: [LoggedMiddleware, CompanyMiddleware, RWAModuleMiddleware],
    },
    {
        name: 'RWA View',
        layout: '/dashboard',
        path: '/rwa/:rwaId',
        component: RWAView,
        middlewares: [LoggedMiddleware, CompanyMiddleware, RWAModuleMiddleware],
    },
    {
        name: 'Create RWA',
        layout: '/dashboard',
        path: '/rwa/create/:type',
        component: RWACreate,
        middlewares: [LoggedMiddleware, CompanyMiddleware, RWAModuleMiddleware],
    },
    {
        name: 'RWA Filtered',
        layout: '/dashboard',
        path: '/rwa/type/:type',
        component: RWAFiltered,
        middlewares: [LoggedMiddleware, CompanyMiddleware, RWAModuleMiddleware],
    },
    {
        name: 'Tokens',
        layout: '/dashboard',
        path: '/tokens',
        component: Tokens,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware],
    },
    {
        name: 'Workflows',
        layout: '/dashboard',
        path: '/workflows',
        component: Workflows,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware],
    },
    {
        name: 'Workflow Editor',
        layout: '/dashboard',
        path: '/workflows/:id',
        component: WorkflowEditor,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware],
    },
    {
        name: 'SSO',
        layout: '/dashboard',
        path: '/sso',
        component: DashboardSSO,
        middlewares: [LoggedMiddleware, EmailVerifiedMiddleware, CompanyMiddleware, SSOModuleMiddleware],
    },
];
